// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"00f2f1ef","529":"afebf361","609":"0e00eb18"}[chunkId] + ".chunk.css";
};